export const seasonSuitesImages = [
  {
    imgNum: 1,
    imgSrc: "SeasonSuites/FieldSuites/field_1.jpg",
    title: "SEASON",
    subTitle: "SUITES",
    desc: "Elevate your game experience all season long with your own private space where you’ll make indelible memories with family and friends.",
    caption: "FIELD SUITE",
    links: [],
  },
  {
    imgNum: 2,
    imgSrc: "SeasonSuites/ClassicSuites/classic_season20_1.jpg",
    title: "",
    subTitle: "",
    desc: "",
    caption: "CLASSIC SUITE",
    links: [],
  },
  {
    imgNum: 3,
    imgSrc: "SeasonSuites/FoundersSuites/founders_1.jpg",
    title: "",
    subTitle: "",
    desc: "",
    caption: "FOUNDERS SUITE",
    links: [],
  },
  {
    imgNum: 4,
    imgSrc: "SeasonSuites/Legacy/legacy_1.jpg",
    title: "",
    subTitle: "",
    desc: "",
    caption: "LEGACY SUITE",
    links: [],
  },
];
